var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuesPaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: "200px",
    width: "200px",
    id: "Layer_1",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3D7296"
    },
    d: "M432.552,441.379H150.069c-14.626,0-26.483-11.857-26.483-26.483V26.483 C123.586,11.857,135.443,0,150.069,0h282.483c14.626,0,26.483,11.857,26.483,26.483v388.414 C459.034,429.523,447.178,441.379,432.552,441.379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7941E"
    },
    d: "M432.552,264.828H150.069c-4.875,0-8.828-3.953-8.828-8.828V26.483c0-4.875,3.953-8.828,8.828-8.828 h282.483c4.875,0,8.828,3.953,8.828,8.828V256C441.379,260.875,437.427,264.828,432.552,264.828z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3D7296"
    },
    d: "M397.241,476.69H114.759c-14.626,0-26.483-11.857-26.483-26.483V61.793 c0-14.626,11.857-26.483,26.483-26.483h282.483c14.626,0,26.483,11.857,26.483,26.483v388.414 C423.724,464.833,411.868,476.69,397.241,476.69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7941E"
    },
    d: "M397.241,300.138H114.759c-4.875,0-8.828-3.953-8.828-8.828V61.793c0-4.875,3.953-8.828,8.828-8.828 h282.483c4.875,0,8.828,3.953,8.828,8.828V291.31C406.069,296.185,402.116,300.138,397.241,300.138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3D7296"
    },
    d: "M361.931,512H79.448c-14.626,0-26.483-11.857-26.483-26.483V97.103 c0-14.626,11.857-26.483,26.483-26.483h282.483c14.626,0,26.483,11.857,26.483,26.483v388.414 C388.414,500.143,376.557,512,361.931,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7941E"
    },
    d: "M361.931,335.448H79.448c-4.875,0-8.828-3.953-8.828-8.828V97.103c0-4.875,3.953-8.828,8.828-8.828 h282.483c4.875,0,8.828,3.953,8.828,8.828v229.517C370.759,331.496,366.806,335.448,361.931,335.448z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M199.604,133.556c-3.448-12.366-14.811-21.004-27.647-21.004h-8.466 c-12.836,0-24.199,8.638-27.647,21.013L95.302,279.526c-1.63,5.879,1.802,11.957,7.672,13.587 c5.854,1.638,11.957-1.793,13.587-7.672l10.016-36.061h82.296l10.016,36.061c1.354,4.879,5.793,8.077,10.621,8.077 c0.983,0,1.974-0.129,2.966-0.405c5.87-1.63,9.302-7.706,7.672-13.587L199.604,133.556z M132.707,227.31l24.396-87.832 c0.793-2.862,3.423-4.857,6.388-4.857h8.466c2.966,0,5.594,1.996,6.388,4.85l24.397,87.84H132.707z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M337.655,271.672v-77.465c0-6.094-4.94-11.034-11.034-11.034c-4.821,0-8.806,3.135-10.31,7.442 c-7.228-4.661-15.782-7.442-25.001-7.442c-25.551,0-46.345,20.793-46.345,46.345v17.655c0,25.551,20.793,46.345,46.345,46.345 c10.301,0,19.733-3.493,27.437-9.202c3.533,5.515,9.682,9.202,16.701,9.202c6.094,0,11.034-4.94,11.034-11.034 C346.483,277.146,342.69,272.69,337.655,271.672z M291.31,271.448c-13.388,0-24.276-10.888-24.276-24.276v-17.655 c0-13.388,10.888-24.276,24.276-24.276c13.388,0,24.276,10.888,24.276,24.276v17.655 C315.586,260.561,304.698,271.448,291.31,271.448z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "lightgray"
    },
    d: "M335.448,397.241H105.931c-4.879,0-8.828-3.948-8.828-8.828s3.948-8.828,8.828-8.828h229.517 c4.879,0,8.828,3.948,8.828,8.828S340.328,397.241,335.448,397.241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "darkgray"
    },
    d: "M247.172,467.862H105.931c-4.879,0-8.828-3.948-8.828-8.828s3.948-8.828,8.828-8.828h141.241 c4.879,0,8.828,3.948,8.828,8.828S252.052,467.862,247.172,467.862z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "darkgray"
    },
    d: "M158.897,432.552h-52.966c-4.879,0-8.828-3.948-8.828-8.828c0-4.879,3.948-8.828,8.828-8.828h52.966 c4.879,0,8.828,3.948,8.828,8.828C167.724,428.604,163.776,432.552,158.897,432.552z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "darkgray"
    },
    d: "M335.448,432.552H194.207c-4.879,0-8.828-3.948-8.828-8.828c0-4.879,3.948-8.828,8.828-8.828 h141.241c4.879,0,8.828,3.948,8.828,8.828C344.276,428.604,340.328,432.552,335.448,432.552z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuesPaper);
export default __webpack_public_path__ + "static/media/ques-paper.c132f661e72784b2b9764287801a9710.svg";
export { ForwardRef as ReactComponent };